'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	return Array.prototype.flatten || implementation;
};



//////////////////
// WEBPACK FOOTER
// ./~/array.prototype.flatten/polyfill.js
// module id = 261
// module chunks = 35783957827783 172322841747965